import React, { useContext } from 'react';
import instance from '../config/axios-instance';
import AuthContext from '../store/auth-context';
import AxiosContext from '../store/axios-context';

function Wrapper({ children }) {
  const axiosInstance = instance;
  const pageExists = axiosInstance !== null;

  const authCtx = useContext(AuthContext);
  if (authCtx.isLoggedIn && authCtx.token) {
    axiosInstance.defaults.headers.common['Authorization'] =
      'Bearer ' + authCtx.token;
  } else {
    delete axiosInstance.defaults.headers.common['Authorization'];
  }

  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response?.status;
      const message = error.response?.data?.errors;
      const isAuthError =
        status === 401 ||
        (status === 400 &&
          (message === 'Invalid user credentials' || message === 'Unauthenticated'));

      if (isAuthError) {
        authCtx.logout();
      }

      return Promise.reject(error);
    }
  );

  return (
    <AxiosContext.Provider value={{ instance: axiosInstance }}>
      {pageExists ? children : ''}
    </AxiosContext.Provider>
  );
}

export default Wrapper;
